import { useQuery } from '@tanstack/react-query';
import { getEditAgenticWorkflow } from 'services/api/WorkflowServiceAPI';
import { queryKeys } from '../queryKeys';

export const useGetEditAgenticWorkflow = ({ id, isEnabled }: { id: string; isEnabled: boolean }) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.editAgenticWorkflow(id),
        queryFn: () => getEditAgenticWorkflow(id),
        enabled: isEnabled,
    });

    return { editAgenticWorkflow: data, isLoadingEditAgenticWorkflow: isLoading, ...rest };
};
